import { Channel } from 'lib-shared-types-channels';
import { useMemo } from 'react';

import { channelAttributes } from 'utils/channels';
import { getChannelFeatureFlagsStatus } from 'utils/featureFlagging/channelFeatureFlags';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
import { ConversationsStaticFilterConfig } from '../static/conversationsStaticFilter.types';

/** Represents the component for filtering the conversations by channel. */
export const ConversationsChannelFilter = (): JSX.Element => {
  const { instagramManagement } = useFeatureFlag(['instagram-management']);
  const channelFeatureFlags = getChannelFeatureFlagsStatus();

  const items: readonly ConversationsStaticFilterConfig['channel'][] =
    useMemo(() => {
      return Object.entries(channelAttributes)
        .filter(([channelKey, _]) => {
          const channel = channelKey as Channel;

          if (channel === 'facebook_messenger') {
            // Instagram conversations appear as Facebook conversations
            return channelFeatureFlags.get(channel) || instagramManagement;
          }
          return channelFeatureFlags.get(channel);
        })
        .map(([channelKey, { icon, name }]) => ({
          id: channelKey as Channel,
          icon,
          name,
        }));
    }, [instagramManagement, channelFeatureFlags]);

  return <ConversationsStaticFilter type="channel" items={items} />;
};
